import React, { useState } from "react"

export default function DocumentUpload({ formData, setFormData }) {
  const [modalImage, setModalImage] = useState(null)
  const frontPreview = formData.document_front || null
  const backPreview = formData.document_back || null

  const handleImageChange = (e, side) => {
    const file = e.target.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = () => {
      const imageData = reader.result
      setFormData((prev) => ({
        ...prev,
        [side === "front" ? "document_front" : "document_back"]: imageData,
      }))
    }
    reader.readAsDataURL(file)
  }

  const handleRemoveImage = (side) => {
    setFormData((prev) => ({
      ...prev,
      [side === "front" ? "document_front" : "document_back"]: "",
    }))
  }

  const openModal = (image) => setModalImage(image)
  const closeModal = (e) => {
    e.stopPropagation()
    setModalImage(null)
  }

  return (
    <>
      <label className="document-upload-label">
        Upload documenti (fronte e retro)
      </label>

      <div className="document-upload-row">
        <div className="document-side">
          <label className="document-label">Immagine fronte</label>
          {!frontPreview ? (
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, "front")}
              className="document-file-input"
            />
          ) : (
            <div
              className="document-preview"
              onClick={() => openModal(frontPreview)}
            >
              <img src={frontPreview} alt="front" className="document-image" />
              <button
                type="button"
                className="document-delete-button"
                onClick={(e) => {
                  e.stopPropagation()
                  handleRemoveImage("front")
                }}
              >
                ×
              </button>
              <div className="document-overlay">Click to view</div>
            </div>
          )}
        </div>

        <div className="document-side">
          <label className="document-label">Immagine retro</label>
          {!backPreview ? (
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, "back")}
              className="document-file-input"
            />
          ) : (
            <div className="document-preview" onClick={() => openModal(backPreview)}>
              <img src={backPreview} alt="back" className="document-image" />
              <button
                type="button"
                className="document-delete-button"
                onClick={(e) => {
                  e.stopPropagation()
                  handleRemoveImage("back")
                }}
              >
                ×
              </button>
              <div className="document-overlay">Click to view</div>
            </div>
          )}
        </div>
      </div>

      {modalImage && (
        <div className="document-modal" onClick={closeModal}>
          <div
            className="document-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={modalImage} alt="Document preview" className="modal-image" />
            <button onClick={closeModal} className="modal-close-button">
              ×
            </button>
          </div>
        </div>
      )}
    </>
  )
}
